function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("title", null, "ICONS/FIGURES/legend-eau-cours-invisible");

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Symbols",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "ICONS/FIGURES/legend-eau-cours-invisible",
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("polygon", {
  id: "Path",
  fill: "#4D88FF",
  points: "28 10 28 20 2 20 2 10"
}), /*#__PURE__*/React.createElement("path", {
  d: "M8,10 L8,20 L2,20 L2,10 L8,10 Z M21,10 L21,20 L14,20 L14,10 L21,10 Z",
  id: "Combined-Shape",
  fill: "#80D4FF"
})));

const SvgIco30EauCoursInvisible = ({
  svgRef,
  title,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "30px",
  height: "30px",
  viewBox: "0 0 30 30",
  ref: svgRef
}, props), title === undefined ? _ref : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIco30EauCoursInvisible, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/ico-30-eauCoursInvisible.7b8e9ccc.svg";
export { ForwardRef as ReactComponent };